// TOP LEVEL IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
// MODULES
import AccountHelpers from 'lib/helpers/AccountHelpers';
import ErrorHelpers from 'lib/helpers/ErrorHelpers';
// ANTD
import Menu from 'antd/lib/menu';
// STYLES
// import '/imports/ui/layouts/app/index.less';

class DropdownMenu extends React.PureComponent {
  render() {
    const { user, menuItems } = this.props;
    return (
      <div style={{ border: '1px solid #efefef', background: '#efefef' }}>
        <Menu className="heyned-dropdown" onClick={this.props.onChange}>
          {menuItems.map(item => (
            <Menu.Item key={item.key} className="dropdown-menu-item" style={{ fontSize: 16 }}>
              <div to={item.key}> {item.label}</div>
            </Menu.Item>
          ))}
        </Menu>
      </div>
    );
  }
}

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/routes/app-studio/DropdownMenu/index.js